<template>
    <div class="page-container">
        <!-- 顶部轮播图 -->
        <div class="header-bg">
            <van-swipe
                    class="banner-swipe"
                    v-if="bannerList.length > 0"
                    autoplay
                    interval="3000"
                    circular
                    indicator-color="rgba(255, 255, 255, 0.5)"
                    indicator-active-color="#ffffff"
            >
                <van-swipe-item v-for="item in bannerList" :key="item.id">
                    <img class="banner-image" :src="item.imageUrl" mode="aspectFill"/>
                </van-swipe-item>
            </van-swipe>
            <img
                    class="bg-image"
                    v-else
                    src="https://images.unsplash.com/photo-1587351021759-3e566b2af923?w=750&h=400&fit=crop"
                    mode="aspectFill"
            />

            <!-- 企业选择 -->
            <div class="enterprise-picker" @click="enterpriseClick">
                <div class="enterprise-select">
                    <span class="enterprise-name">{{ selectedEnterprise.name || '请选择企业' }}</span>
                    <span class="arrow">▼</span>
                </div>
            </div>
        </div>

        <!-- 企业选择弹窗 -->
        <van-popup v-model="enterpriseShow" position="bottom" @close="onEnterpriseClose">
            <van-picker
                    show-toolbar
                    :columns="enterpriseList"
                    @cancel="onEnterpriseClose"
                    @confirm="onEnterpriseChange"
            />
        </van-popup>


        <!-- 表单卡片 -->
        <div class="form-card" v-if="isLoggedIn">
            <div class="form-item">
                <span class="form-label">病区/科室</span>
                <div class="division-picker" @click="divisionClick">
                    <div class="form-value">
                        <span class="placeholder" v-if="!selectedDivision.name">请选择病区/科室</span>
                        <span class="value-text" v-else>{{ selectedDivision.name }}</span>
                        <span class="arrow">></span>
                    </div>
                </div>
            </div>

            <!-- 病区选择弹窗 -->
            <van-popup v-model="divisionShow" position="bottom" @close="onDivisionClose">
                <van-picker
                        show-toolbar
                        :columns="divisionList"
                        @cancel="onDivisionClose"
                        @confirm="onDivisionChange"
                />
            </van-popup>

            <div class="form-item">
                <span class="form-label">床位号</span>
                <div class="form-value">
                    <input
                            class="bed-input"
                            type="number"
                            placeholder="请输入床位号"
                            v-model="bedNumber"
                            :disabled="noBedAssigned"
                    />
                    <span class="unit">床</span>
                </div>
            </div>

            <div class="form-item checkbox-item">
                <van-checkbox v-model="noBedAssigned" @change="onNoBedChange">
                    暂未分配床位
                </van-checkbox>
            </div>

            <van-button type="primary" class="submit-btn" @click="handleOrder">
                立即下单
            </van-button>
        </div>

        <!-- 功能入口 -->
        <div class="feature-section" v-if="isLoggedIn">
            <div class="feature-item" @click="goToFeature" data-type="renew">
                <div class="feature-icon icon-blue">
                    <img src="https://img.icons8.com/color/96/receipt.png" mode="aspectFit"/>
                </div>
                <span class="feature-title">续费补缴</span>
                <span class="feature-desc">补缴剩余费用</span>
            </div>
            <div class="feature-item" @click="goToFeature" data-type="home">
                <div class="feature-icon icon-orange">
                    <img src="https://img.icons8.com/color/96/nurse-male.png" mode="aspectFit"/>
                </div>
                <span class="feature-title">居家服务</span>
                <span class="feature-desc">居家服务预约</span>
            </div>
            <div class="feature-item" @click="goToFeature" data-type="hospital">
                <div class="feature-icon icon-blue">
                    <img src="https://img.icons8.com/color/96/hospital.png" mode="aspectFit"/>
                </div>
                <span class="feature-title">院区服务</span>
                <span class="feature-desc">提供配送等服务</span>
            </div>
        </div>

        <div class="tab-bar">
            <div class="tab-item active" @click="handleTabClick('home')">
                <span class="tab-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                    </svg>
                </span>
                <span class="tab-text">首页</span>
            </div>
            <div class="tab-item" @click="handleTabClick('mine')">
                <span class="tab-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                </span>
                <span class="tab-text">我的</span>
            </div>
        </div>
    </div>
</template>

<script>
    import {Toast, Dialog} from 'vant'
    import wxAuth from "@/utils/wxAuth";

    export default {
        name: 'caregiverIndex',
        data() {
            return {
                // appId: 'wx2b735862ca820115',
                appId:'',
                isLoggedIn: true,
                userInfo: {},
                needPhoneNumber: false,

                // 轮播图
                bannerList: [],

                // 企业选择
                enterpriseList: [],
                selectedEnterpriseIndex: 0,
                selectedEnterprise: {},
                enterpriseShow: false,

                // 病区选择
                divisionList: [],
                selectedDivisionIndex: 0,
                selectedDivision: {},
                divisionShow: false,

                // 床位
                bedNumber: '',
                noBedAssigned: false,
                _hasLoadedData: false
            }
        },
        created(){
            this.appId=this.$route.query.appId
        },
        mounted() {
            this.autoLogin();
        },
        activated() {

        },
        methods: {
            async autoLogin() {
                const token = localStorage.getItem("cgtoken");
                if (token) {
                    this.fetchEnterpriseList();
                    return;
                }

                // 不是微信浏览器
                if (!wxAuth.isWechat()) {
                    alert("请在微信内打开");
                    return;
                }

                // 1. 看URL里有没有 code
                const urlParams = new URLSearchParams(window.location.search);
                const code = urlParams.get('code');
                if (code) {
                    try {
                        // 2. 拿 code 登录
                        this.getToken(code)
                    } catch (err) {
                        console.error("登录失败", err);
                    }
                    return;
                }

                // 没有 code → 跳授权
                if (this.appId) {
                    const appId = this.appId; // 你的微信公众号AppID
                    const redirectUri = encodeURIComponent('https://wxztc.com.cn/#/caregiverIndex'); // 替换为你的回调域名，必须在微信公众号后台配置
                    const state = 'custom_state'; // 可选参数，用于保持状态，防止CSRF攻击
                    const scope = 'snsapi_base'; // 授权作用域，snsapi_base（静默授权）或 snsapi_userinfo（弹窗授权）
                    const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;
                    window.location.href = authUrl;
                }
            },

            getToken(code) {
                let url = "/api-enterprise/wx/login3"
                let query = {
                    code: code,
                    phoneCode: '',
                }

                this.$api.post(url, query, response => {
                    if (response.data.result == "success") {
                        localStorage.setItem("cgtoken", response.data.token);
                        this.fetchEnterpriseList()
                    }
                })
            },
            /**
             * 检查登录状态
             */
            checkLoginStatus() {
                const token = localStorage.getItem('token')
                const userInfo = localStorage.getItem('userInfo')
                    ? JSON.parse(localStorage.getItem('userInfo'))
                    : {}

                if (token && userInfo) {
                    this.isLoggedIn = true
                    this.userInfo = userInfo
                    if (!this._hasLoadedData) {
                        this._hasLoadedData = true
                        this.fetchEnterpriseList()
                    }
                } else {
                    this.isLoggedIn = false
                    this.userInfo = {}
                }
            },

            /**
             * 获取企业列表
             */
            async fetchEnterpriseList() {
                try {
                    let url = "/api-enterprise/list"
                    this.$api.post(url, {}, response => {
                        if (response.data.result == "success") {
                            let datas = response.data.data || []
                            datas.map((item) => {
                                item.text = item.name
                            })
                            this.enterpriseList = datas

                            if (datas.length > 0) {
                                let cachedEnterpriseId = this.getCachedEnterpriseId()
                                let defaultIndex = 0

                                if (cachedEnterpriseId) {
                                    const cachedIndex = datas.findIndex(item => item.enterpriseId == cachedEnterpriseId)
                                    if (cachedIndex !== -1) {
                                        defaultIndex = cachedIndex
                                    }
                                }


                                this.selectedEnterpriseIndex = defaultIndex
                                this.selectedEnterprise = datas[defaultIndex]


                                this.cacheSelectedEnterprise(datas[defaultIndex])
                                this.fetchDivisionList(datas[defaultIndex].enterpriseId)
                                this.fetchBannerList(datas[defaultIndex].enterpriseId)
                            }
                        }
                    })

                } catch (err) {
                    console.error('fetchEnterpriseList fail:', err)
                }
            },

            enterpriseClick() {
                this.enterpriseShow = true
            },
            onEnterpriseClose() {
                this.enterpriseShow = false
            },

            /**
             * 企业选择变化
             */
            onEnterpriseChange(selectedOptions, index) {
                const enterprise = this.enterpriseList[index]
                this.selectedEnterpriseIndex = index
                this.selectedEnterprise = enterprise
                this.cacheSelectedEnterprise(enterprise)
                this.selectedDivision = {}
                this.selectedDivisionIndex = 0
                this.divisionList = []
                this.enterpriseShow = false
                this.bedNumber = ''

                this.fetchDivisionList(enterprise.enterpriseId)
                this.fetchBannerList(enterprise.enterpriseId)
            },

            /**
             * 缓存选中的企业ID
             */
            cacheSelectedEnterprise(enterprise) {
                try {
                    localStorage.setItem('caregiver_selected_enterprise_id', enterprise.enterpriseId)
                    localStorage.setItem('caregiver_selected_enterprise_name', enterprise.name)
                } catch (e) {
                    console.error('cache enterprise fail:', e)
                }
            },

            /**
             * 获取缓存的企业ID
             */
            getCachedEnterpriseId() {
                try {
                    return localStorage.getItem('caregiver_selected_enterprise_id')
                } catch (e) {
                    console.error('get cached enterprise fail:', e)
                    return null
                }
            },

            /**
             * 获取轮播图
             */
            async fetchBannerList(enterpriseId) {
                if (!enterpriseId) return
                try {
                    let url = "/api-enterprise/banner/list"
                    this.$api.post(url, {enterpriseId}, response => {
                        if (response.data.result == "success") {
                            this.bannerList = response.data.data

                        }
                    })
                } catch (err) {
                    console.error('fetchBannerList fail:', err)
                }
            },

            /**
             * 获取病区列表
             */
            async fetchDivisionList(enterpriseId) {
                if (!enterpriseId) return
                try {
                    let url = "/api-enterprise/division/list"
                    this.$api.post(url, {enterpriseId}, response => {
                        if (response.data.result == "success") {
                            let datas = response.data.data || []
                            datas.map((item) => {
                                item.text = item.name
                            })
                            this.divisionList = datas
                        }
                    })
                } catch (err) {
                    console.error('fetchDivisionList fail:', err)
                }
            },

            divisionClick() {
                this.divisionShow = true
            },
            onDivisionClose() {
                this.divisionShow = false
            },

            /**
             * 病区选择变化
             */
            onDivisionChange(selectedOptions, index) {
                const division = this.divisionList[index]
                this.selectedDivisionIndex = index
                this.selectedDivision = division
                this.divisionShow = false
                this.bedNumber = ''
            },

            /**
             * 暂未分配床位切换
             */
            onNoBedChange(val) {
                if (val) {
                    this.bedNumber = ''
                }
            },

            /**
             * 立即下单
             */
            handleOrder() {
                if (!this.selectedDivision.name) {
                    Toast('请选择病区/科室')
                    return
                }
                if (!this.noBedAssigned && !this.bedNumber) {
                    Toast('请输入床位号')
                    return
                }

                const orderData = {
                    enterpriseId: this.selectedEnterprise.enterpriseId,
                    enterpriseName: this.selectedEnterprise.name,
                    divisionId: this.selectedDivision.id || this.selectedDivision.divisionId,
                    divisionName: this.selectedDivision.name,
                    bedNumber: this.noBedAssigned ? '' : this.bedNumber
                }

                localStorage.setItem('signatureUrl', null);
                localStorage.setItem('selectedPatient', null);
                localStorage.setItem('orderDetail', null);

                // 跳转
                this.$router.push({
                    path: '/orderConfirm',
                    query: {
                        data: encodeURIComponent(JSON.stringify(orderData))
                    }
                })
            },

            /**
             * 功能入口
             */
            goToFeature(e) {
                Toast('功能开发中')
            },

            handleTabClick(type) {
                if (type === 'mine') {
                    this.$router.push({path: '/my'})
                }
            }

        }
    }
</script>

<style scoped>
    .page-container {
        min-height: 100vh;
        background-color: #f5f5f5;
        padding-bottom: 20px;
    }

    /* 顶部背景 */
    .header-bg {
        position: relative;
        width: 100%;
        height: 210px;
        overflow: hidden;
    }

    .banner-swiper {
        width: 100%;
        height: 100%;
    }

    .banner-image {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
    }

    .bg-image {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
    }

    /* 企业选择 */
    .enterprise-picker {
        position: absolute;
        top: 40px;
        left: 15px;
        z-index: 10;
    }

    .enterprise-select {
        display: flex;
        align-items: center;
        background-color: rgba(255, 255, 255, 0.95);
        padding: 7px 14px;
        border-radius: 16px;
        box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
    }

    .enterprise-name {
        font-size: 14px;
        color: #333;
        max-width: 210px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .arrow {
        font-size: 10px;
        color: #666;
        margin-left: 5px;
    }

    /* 登录弹层 */
    .login-mask {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.6);
        z-index: 100;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .login-dialog {
        width: 80%;
        background-color: #fff;
        border-radius: 10px;
        padding: 30px 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .login-title {
        font-size: 18px;
        font-weight: bold;
        color: #333;
        margin-bottom: 10px;
    }

    .login-tip {
        font-size: 14px;
        color: #999;
        margin-bottom: 30px;
    }

    .login-btn {
        width: 100%;
        height: 44px;
        line-height: 44px;
        background-color: #07c160;
        color: #fff;
        font-size: 16px;
        border-radius: 22px;
        border: none;
        margin-bottom: 10px;
        display: block;
        padding: 0;
        margin: auto;
    }

    .login-btn::after {
        border: none;
    }

    .login-btn-simple {
        width: 100%;
        height: 44px;
        line-height: 44px;
        background-color: #f5f5f5;
        color: #666;
        font-size: 14px;
        border-radius: 22px;
        border: none;
    }

    .login-btn-simple::after {
        border: none;
    }

    /* 表单卡片 */
    .form-card {
        margin: -50px 15px 15px;
        background-color: #fff;
        border-radius: 10px;
        padding: 5px 15px 15px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
        position: relative;
        z-index: 5;
    }

    .form-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 15px 0;
        border-bottom: 1px solid #f0f0f0;
    }

    .form-item:last-of-type {
        border-bottom: none;
    }

    .form-label {
        font-size: 15px;
        color: #333;
        flex-shrink: 0;
        margin-right: 10px;
        font-weight: 500;
    }

    .form-value {
        display: flex;
        align-items: center;
        flex: 1;
        justify-content: flex-end;
    }

    .division-picker {
        flex: 1;
    }

    .placeholder {
        font-size: 15px;
        color: #ccc;
    }

    .value-text {
        font-size: 15px;
        color: #333;
    }

    .bed-input {
        /* 去掉边框 */
        border: none;
        outline: none;
        background: transparent;
        /* 占位文字和输入文字都右对齐 */
        text-align: right;
        font-size: 14px;
        color: #333;
        width: 100%;
    }

    .bed-input::placeholder {
        color: #ccc;
        /* 确保占位文字右对齐 */
        text-align: right;
    }

    .unit {
        font-size: 15px;
        color: #333;
        margin-left: 5px;
    }

    .checkbox-item {
        justify-content: flex-start;
        border-bottom: none;
        padding: 10px 0;
    }

    .bed-checkbox {
        transform: scale(0.8);
    }

    .checkbox-label {
        font-size: 14px;
        color: #666;
        margin-left: 5px;
    }

    /* 提交按钮 */
    .submit-btn {
        display: block;
        padding: 0;
        margin: auto;
        width: 100%;
        height: 45px;
        line-height: 45px;
        background-color: rgba(0, 184, 147, 0.72);
        color: #fff;
        font-size: 16px;
        border-radius: 22.5px;
        margin-top: 10px;
        border: none;
    }

    .submit-btn::after {
        border: none;
    }

    /* 功能区域 */
    .feature-section {
        margin: 0 15px;
        background-color: #fff;
        border-radius: 10px;
        padding: 20px 10px;
        display: flex;
        justify-content: space-around;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    }

    .feature-item {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .feature-icon {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 8px;
    }

    .feature-icon img {
        width: 30px;
        height: 30px;
    }

    .icon-blue {
        background-color: #e6f7ff;
    }

    .icon-orange {
        background-color: #fff2e8;
    }

    .feature-title {
        font-size: 14px;
        color: #333;
        margin-bottom: 4px;
        font-weight: 500;
    }

    .feature-desc {
        font-size: 11px;
        color: #999;
    }

    .tab-bar {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        height: 56px;
        background: #ffffff;
        display: flex;
        justify-content: space-around;
        align-items: center;
        box-shadow: 0 -4px 15px rgba(0, 0, 0, 0.06);
        z-index: 999;
        padding-bottom: env(safe-area-inset-bottom);
    }
    .tab-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        flex: 1;
        height: 100%;
        color: #999999;
        font-size: 12px;
        transition: all 0.2s ease;
        padding-top: 4px;
    }
    .tab-item.active {
        color: #32C5A7;
    }
    .tab-icon {
        width: 24px;
        height: 24px;
        margin-bottom: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .tab-icon svg {
        width: 100%;
        height: 100%;
    }
    .tab-text {
        font-size: 11px;
        font-weight: 500;
    }
</style>
